// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { BiwaveClient } from '@biwave/core';

export function installNavigationBreadcrumbs(client: BiwaveClient): () => void {
  let lastUrl = window.location.href;

  const recordNavigation = (): void => {
    const currentUrl = window.location.href;
    if (currentUrl === lastUrl) return;

    client.addBreadcrumb({
      type: 'navigation',
      category: 'navigation',
      level: 'info',
      data: { from: lastUrl, to: currentUrl },
    });
    lastUrl = currentUrl;
  };

  const originalPushState = history.pushState.bind(history);
  const originalReplaceState = history.replaceState.bind(history);

  history.pushState = function patchedPushState(...args: Parameters<typeof history.pushState>) {
    originalPushState(...args);
    recordNavigation();
  };

  history.replaceState = function patchedReplaceState(
    ...args: Parameters<typeof history.replaceState>
  ) {
    originalReplaceState(...args);
    recordNavigation();
  };

  window.addEventListener('popstate', recordNavigation);

  return () => {
    history.pushState = originalPushState;
    history.replaceState = originalReplaceState;
    window.removeEventListener('popstate', recordNavigation);
  };
}
